import React, { SVGProps } from 'react'
const SvgGooglePlayStore = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={143}
    height={42}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#000"
      d="M137.704 41.312H5.296C2.385 41.312 0 38.986 0 36.148V5.164C0 2.325 2.385 0 5.296 0h132.408C140.615 0 143 2.325 143 5.164v30.984c0 2.838-2.385 5.163-5.296 5.163Z"
    />
    <path
      fill="#A6A6A6"
      d="M137.704.828c2.452 0 4.447 1.945 4.447 4.336v30.984c0 2.39-1.995 4.336-4.447 4.336H5.296c-2.452 0-4.447-1.946-4.447-4.336V5.164c0-2.39 1.995-4.336 4.447-4.336h132.408Zm0-.828H5.296C2.385 0 0 2.325 0 5.164v30.984c0 2.838 2.385 5.163 5.296 5.163h132.408c2.911 0 5.296-2.325 5.296-5.163V5.164C143 2.325 140.615 0 137.704 0Z"
    />
    <path
      fill="url(#Google-Play-Store_svg__a)"
      d="M11.054 7.785c-.311.318-.492.812-.492 1.453v22.84c0 .64.18 1.134.492 1.452l.076.07 13.127-12.794v-.302L11.13 7.71l-.076.075Z"
    />
    <path
      fill="url(#Google-Play-Store_svg__b)"
      d="m28.629 25.073-4.371-4.266v-.302l4.376-4.267.098.055 5.182 2.875c1.48.816 1.48 2.159 0 2.98l-5.182 2.87-.103.055Z"
    />
    <path
      fill="url(#Google-Play-Store_svg__c)"
      d="m28.732 25.017-4.474-4.362L11.055 33.53c.49.504 1.292.564 2.203.06l15.474-8.573Z"
    />
    <path
      fill="url(#Google-Play-Store_svg__d)"
      d="M28.732 16.293 13.258 7.72c-.911-.499-1.712-.438-2.203.066l13.203 12.87 4.474-4.363Z"
    />
    <g fill="#fff" stroke="#fff" strokeMiterlimit={10} strokeWidth={0.04}>
      <path d="M50.23 10.58c0 .862-.266 1.552-.787 2.068-.6.61-1.381.917-2.339.917-.915 0-1.696-.312-2.337-.928-.642-.625-.962-1.392-.962-2.31 0-.917.32-1.684.962-2.304.641-.62 1.422-.933 2.337-.933a3.4 3.4 0 0 1 1.304.262c.414.172.75.404.993.69l-.553.545c-.425-.489-1.004-.73-1.744-.73a2.46 2.46 0 0 0-1.737.685c-.486.46-.73 1.055-.73 1.786 0 .73.244 1.33.73 1.79.491.453 1.07.686 1.737.686.709 0 1.304-.233 1.775-.691.31-.303.486-.722.532-1.256h-2.307v-.746h3.077c.038.161.048.317.048.468ZM55.107 7.993h-2.89v1.962h2.605v.746h-2.605v1.963h2.89v.76h-3.709V7.232h3.71v.76ZM58.552 13.424h-.818V7.993H55.96v-.76h4.365v.76h-1.774v5.43ZM63.492 13.424V7.232h.817v6.192h-.817ZM67.927 13.424h-.812V7.993h-1.78v-.76h4.372v.76h-1.78v5.43ZM77.972 12.627c-.626.626-1.402.938-2.328.938-.93 0-1.707-.312-2.333-.938-.625-.625-.936-1.392-.936-2.3 0-.907.311-1.674.936-2.299.626-.626 1.402-.938 2.333-.938.92 0 1.696.312 2.323.944.63.63.941 1.391.941 2.294 0 .907-.311 1.674-.936 2.299Zm-4.056-.52c.472.464 1.045.697 1.728.697.678 0 1.257-.233 1.723-.696.47-.464.708-1.059.708-1.78 0-.722-.238-1.317-.708-1.78-.466-.464-1.045-.696-1.723-.696-.683 0-1.256.232-1.728.695-.47.464-.708 1.059-.708 1.78 0 .722.238 1.317.708 1.78ZM80.055 13.424V7.232h.993l3.087 4.816h.036l-.036-1.19V7.232h.817v6.192H84.1L80.866 8.37h-.035l.035 1.195v3.858h-.811Z" />
    </g>
    <path
      fill="#fff"
      d="M72.177 22.465c-2.488 0-4.52 1.846-4.52 4.393 0 2.527 2.032 4.392 4.52 4.392 2.493 0 4.526-1.865 4.526-4.392 0-2.547-2.033-4.393-4.526-4.393Zm0 7.055c-1.365 0-2.54-1.098-2.54-2.662 0-1.584 1.175-2.663 2.54-2.663s2.545 1.08 2.545 2.663c0 1.564-1.18 2.662-2.545 2.662Zm-9.863-7.055c-2.493 0-4.52 1.846-4.52 4.393 0 2.527 2.027 4.392 4.52 4.392 2.492 0 4.52-1.865 4.52-4.392 0-2.547-2.028-4.393-4.52-4.393Zm0 7.055c-1.366 0-2.545-1.098-2.545-2.662 0-1.584 1.179-2.663 2.545-2.663 1.365 0 2.54 1.08 2.54 2.663 0 1.564-1.175 2.662-2.54 2.662Zm-11.736-5.708v1.867h4.572c-.134 1.043-.492 1.81-1.04 2.344-.667.646-1.706 1.362-3.532 1.362-2.814 0-5.017-2.214-5.017-4.957 0-2.744 2.203-4.958 5.017-4.958 1.52 0 2.628.58 3.445 1.331l1.349-1.315c-1.143-1.064-2.663-1.881-4.794-1.881-3.859 0-7.101 3.06-7.101 6.823 0 3.761 3.242 6.822 7.1 6.822 2.086 0 3.652-.666 4.884-1.915 1.262-1.23 1.655-2.96 1.655-4.357 0-.434-.037-.833-.103-1.166h-6.435Zm47.992 1.447c-.372-.982-1.52-2.794-3.858-2.794-2.318 0-4.247 1.78-4.247 4.393 0 2.461 1.91 4.392 4.469 4.392 2.07 0 3.264-1.23 3.755-1.946l-1.536-.998c-.512.73-1.21 1.214-2.219 1.214-1.002 0-1.721-.447-2.182-1.33l6.026-2.431-.208-.5Zm-6.144 1.463a2.438 2.438 0 0 1 2.353-2.562c.787 0 1.454.384 1.676.933l-4.029 1.629Zm-4.898 4.261h1.981v-12.91h-1.98v12.91Zm-3.244-7.54h-.066c-.445-.513-1.293-.978-2.368-.978-2.257 0-4.32 1.932-4.32 4.408 0 2.462 2.063 4.377 4.32 4.377 1.075 0 1.923-.468 2.368-.997h.066v.63c0 1.679-.92 2.581-2.404 2.581-1.21 0-1.961-.852-2.27-1.568l-1.723.7c.496 1.165 1.81 2.598 3.993 2.598 2.322 0 4.282-1.332 4.282-4.574v-7.887h-1.878v.71ZM82.02 29.52c-1.365 0-2.508-1.114-2.508-2.647 0-1.548 1.143-2.678 2.508-2.678 1.345 0 2.406 1.13 2.406 2.678 0 1.533-1.06 2.647-2.406 2.647Zm25.825-11.447h-4.738v12.91h1.976v-4.891h2.762c2.194 0 4.345-1.548 4.345-4.01 0-2.46-2.157-4.009-4.345-4.009Zm.051 6.223h-2.813v-4.427h2.813a2.27 2.27 0 0 1 2.318 2.213c0 1-.843 2.214-2.318 2.214Zm12.212-1.855c-1.427 0-2.911.614-3.522 1.976l1.753.717c.378-.717 1.072-.95 1.805-.95 1.025 0 2.064.601 2.08 1.661v.136c-.357-.202-1.123-.5-2.064-.5-1.888 0-3.812 1.013-3.812 2.905 0 1.73 1.546 2.844 3.285 2.844 1.329 0 2.063-.585 2.524-1.265h.067v.997h1.908V26.01c0-2.289-1.753-3.57-4.024-3.57Zm-.238 7.074c-.646 0-1.547-.312-1.547-1.093 0-1 1.123-1.383 2.095-1.383.87 0 1.278.188 1.806.434-.155 1.196-1.21 2.042-2.354 2.042Zm11.214-6.791-2.271 5.596h-.068l-2.347-5.596h-2.131l3.528 7.82-2.013 4.352h2.064l5.436-12.172h-2.198Zm-17.808 8.26h1.981v-12.91h-1.981v12.91Z"
    />
    <defs>
      <linearGradient
        id="Google-Play-Store_svg__a"
        x1={23.092}
        x2={5.765}
        y1={32.315}
        y2={14.544}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF" />
        <stop offset={0.007} stopColor="#00A1FF" />
        <stop offset={0.26} stopColor="#00BEFF" />
        <stop offset={0.512} stopColor="#00D2FF" />
        <stop offset={0.76} stopColor="#00DFFF" />
        <stop offset={1} stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="Google-Play-Store_svg__b"
        x1={35.84}
        x2={10.209}
        y1={20.654}
        y2={20.654}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000" />
        <stop offset={0.409} stopColor="#FFBD00" />
        <stop offset={0.775} stopColor="orange" />
        <stop offset={1} stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="Google-Play-Store_svg__c"
        x1={26.299}
        x2={2.803}
        y1={18.284}
        y2={-5.815}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44" />
        <stop offset={1} stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="Google-Play-Store_svg__d"
        x1={7.731}
        x2={18.223}
        y1={41.129}
        y2={30.368}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071" />
        <stop offset={0.069} stopColor="#2DA771" />
        <stop offset={0.476} stopColor="#15CF74" />
        <stop offset={0.801} stopColor="#06E775" />
        <stop offset={1} stopColor="#00F076" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgGooglePlayStore
